// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604300803/js/" + chunkId + "." + {"44":"4317e8da","225":"f4a3cdbd","481":"b7562e9a","486":"9f9c8aa6","770":"6a91be9f"}[chunkId] + ".0.04684649952297182.chunk.js";
};